import { FormControl, Grid, Radio, RadioGroup } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import { DialogType } from 'commons/Dialog/DialogTypes';
import { DialogWrapper } from 'commons/Dialog/DialogWrapper';
import LocalizedText, { localize } from 'commons/LocalizedText/LocalizedText';
import { FileDropZone } from 'commons/Upload/FileDropzone';
import * as React from 'react';
import { useState } from 'react';
import { LaboratoryReportTypes } from 'utils/constants/laboratory.report.types';

const useStyles = makeStyles((theme) => ({
  content: {
    padding: '20px'
  }
}));


export const ProductTestUploadLaboReportDialog = ({ open, onClose, onSubmit, availableActions}) => {
  const [file, setFile] = useState(null);
  const classes = useStyles();
  const [reportType, setReportType] = useState();

  const handleDropZoneChange = file => (
    setFile(file)
  );

  const handleRadioChange = event => {
    setReportType(event.target.value);
  };

  const preventSubmit = () => {
    return !file || !reportType;
  }

  const handleSubmit = () => {
    onSubmit(file, reportType);
    handleClose();
  };
  const handleClose = () => {
    setFile(null);
    setReportType(null);
    onClose();
  };

  return (
    <DialogWrapper
      onClose={handleClose}
      onSubmit={handleSubmit}
      open={open}
      preventSubmit={preventSubmit()}
      title={localize("addNewReport")}
      variant={DialogType.CONFIRMATION}
    >
      <Grid alignItems={'center'} className={classes.content} container direction={'column'} justifyContent={'center'}>
        <Grid item>
          <Grid alignItems={'center'} className={classes.content} container direction={'row'} justifyContent={'center'} spacing={2}>
            <Grid item>
              <LocalizedText  align='right' isTextLabel >
                reportType
              </LocalizedText>
            </Grid>
            <Grid item>
              <FormControl>
                <RadioGroup
                  onChange={handleRadioChange}
                  row
                  value={reportType}
                >
                  <FormControlLabel
                    control={<Radio />}
                    disabled={!availableActions?.includes("UPLOAD_FAILURE_REPORT")}
                    label={localize(LaboratoryReportTypes.FAILURE_REPORT.TRANSLATION_KEY)} 
                    value={LaboratoryReportTypes.FAILURE_REPORT.ID}/>
                  <FormControlLabel
                    control={<Radio />}
                    disabled={!availableActions?.includes("UPLOAD_LAB_PRODUCT_TEST_REPORT")}
                    label={localize(LaboratoryReportTypes.LAB_PRODUCT_TEST_REPORT.TRANSLATION_KEY)}
                    value={LaboratoryReportTypes.LAB_PRODUCT_TEST_REPORT.ID} />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <FileDropZone onFileDrop={handleDropZoneChange} />
        </Grid>
      </Grid>
    </DialogWrapper>
  );
};